<div class="att-dialog-card">
  <div class="att-dialog-header">
    <h5 class="att-dialog-title">Select IPE Marks Details</h5>
    <button type="button" class="att-dialog-close" (click)="close()" aria-label="Close">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="att-dialog-body">
    <form [formGroup]="IPEMARKSForm" class="att-dialog-form">
      <div class="att-dialog-field">
        <label class="att-dialog-label">Date</label>
        <div class="date-picker-container">
          <input #dateInput type="text" placeholder="DD-MM-YYYY"
            class="form-control att-dialog-input" formControlName="inputdate"
            (change)="testname($event)" readonly>
          <i class="fa fa-calendar att-date-icon"
            (click)="openCalendar($event)"></i>
        </div>
      </div>

      <div class="att-dialog-field">
        <label class="att-dialog-label">Test Name</label>
        <div class="dropdown w-100">
          <button class="att-dialog-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
            type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <span class="dropdown-text">{{ selectedtestname || 'Select Test' }}</span>
          </button>
          <ul class="dropdown-menu w-100 att-dialog-dropdown-menu">
            <li class="att-search-container">
              <input type="text" class="form-control att-search-input" placeholder="Search Test Name"
                [(ngModel)]="testQuery" [ngModelOptions]="{standalone: true}"
                (keyup)="filterTests()" (click)="$event.stopPropagation()">
            </li>
            <li class="list_campus">
              <ng-container *ngFor="let test of filteredTestList">
                <ul class="att-dropdown-item" (click)="selectTest(test)"
                  [class.att-item-selected]="selectedTestCode === test.testCode">
                  <li class="att-item-text">{{ test.testName }}</li>
                  <li><i *ngIf="selectedTestCode === test.testCode" class="fa fa-check att-check-icon"></i></li>
                </ul>
              </ng-container>
            </li>
          </ul>
        </div>
      </div>

      <div class="att-dialog-field">
        <label class="att-dialog-label">Building Name</label>
        <div class="dropdown w-100">
          <button class="att-dialog-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
            type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <span class="dropdown-text">{{ selectedBuildingName || 'Select Building Name' }}</span>
          </button>
          <ul class="dropdown-menu w-100 att-dialog-dropdown-menu">
            <li class="att-search-container">
              <input type="text" class="form-control att-search-input" placeholder="Search Building"
                [(ngModel)]="buildingQuery" [ngModelOptions]="{standalone: true}"
                (keyup)="filterBuildings()" (click)="$event.stopPropagation()">
            </li>
            <li class="list_campus">
              <ng-container *ngFor="let b of filteredBuildingList">
                <ul class="att-dropdown-item" (click)="selectBuilding(b)"
                  [class.att-item-selected]="buildingid == b.buildingId">
                  <li class="att-item-text">{{ b.buildingName }}</li>
                  <li><i *ngIf="buildingid == b.buildingId" class="fa fa-check att-check-icon"></i></li>
                </ul>
              </ng-container>
            </li>
          </ul>
        </div>
      </div>

      <div class="att-dialog-field">
        <label class="att-dialog-label">Section</label>
        <div class="dropdown w-100">
          <button class="att-dialog-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
            type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <span class="dropdown-text">{{ selectedSectionName || 'Select Section' }}</span>
          </button>
          <ul class="dropdown-menu w-100 att-dialog-dropdown-menu">
            <li class="att-search-container">
              <input type="text" class="form-control att-search-input" placeholder="Search Section"
                [(ngModel)]="sectionQuery" [ngModelOptions]="{standalone: true}"
                (keyup)="filterSections()" (click)="$event.stopPropagation()">
            </li>
            <li class="list_campus">
              <ng-container *ngFor="let s of filteredSectionList">
                <ul class="att-dropdown-item" (click)="selectSection(s)"
                  [class.att-item-selected]="selectedSectionId == s.sectionId">
                  <li class="att-item-text">{{ s.sectionName }}</li>
                  <li><i *ngIf="selectedSectionId == s.sectionId" class="fa fa-check att-check-icon"></i></li>
                </ul>
              </ng-container>
            </li>
          </ul>
        </div>
      </div>

      <div class="ipe-nc-section" *ngIf="testWiseSubjects && subjectsState">
        <label class="att-dialog-label">Not conducted list</label>
        <div class="ipe-nc-checks">
          <label class="ipe-nc-check" *ngFor="let subject of testWiseSubjects"
            [attr.for]="'checkbox-' + subject.subject">
            <input id="checkbox-{{subject.subject}}" type="checkbox"
              [checked]="subjectsState[subject.subject] || false"
              (change)="onCheckboxChange(subject.subject, $event)">
            <span>{{ subject.subject }}</span>
          </label>
        </div>
      </div>
    </form>
  </div>

  <div class="att-dialog-actions">
    <button type="button" class="att-dialog-btn att-dialog-btn-search"
      (click)="studentmarkslist()">Search</button>
  </div>
</div>
